import Vuex from 'vuex';

export default new Vuex.Store({
    state:
    {
        headerData: { progress: 0, },
        assignmentGridData: null,
        hasAccessToCourse: 0
    },
    mutations: 
    {
        setLoggedIn(state, loggedIn) 
        {
            state.loggedIn = loggedIn;
            if (!loggedIn) {
                state.assignmentGridData = null;
                state.headerData.progress = 0;
                state.hasAccessToCourse = 0;
            }
        },

        setHeaderData(state, headerData)
        {
            state.headerData = headerData;
        },

        setAssignmentGridData(state, assignmentGridData)
        {
            state.assignmentGridData = assignmentGridData;
        },

        setHasAccessToCourse(state, hasAccessToCourse)
        {
            state.hasAccessToCourse = hasAccessToCourse;
        }
    }
});